import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2C5530] text-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_golf-experience-hub/artifacts/amevwgso_logo-for-web%20copy.jpg" 
                alt="Quiet Mind Golf" 
                className="h-12 w-auto bg-white rounded-full p-1"
              />
              <span className="font-['Playfair_Display'] text-xl font-medium">
                Quiet Mind Golf
              </span>
            </div>
            <p className="text-white/70 max-w-md leading-relaxed mb-6">
              Tour-proven performance coaching for golfers wanting to improve both their mental and physical games together.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/in/scottyritchie/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-medium mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'About Scott', path: '/about' },
                { name: 'Mental Golf Blog', path: '/blog' },
                { name: 'Contact', path: '/contact' },
                { name: 'Client Portal', path: '/login' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 hover:text-white transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-medium mb-6 text-white">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:scott@quietmindgolf.co.uk"
                  className="flex items-start gap-3 text-white/70 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>scott@quietmindgolf.co.uk</span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+447455558064"
                  className="flex items-start gap-3 text-white/70 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>+44 7455 558064</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>+64 27 410 8444</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Quiet Mind Golf. All rights reserved.
          </p>
          <p className="text-white/50 text-sm">
            Performance coaching for golfers at all levels
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
